import { useId } from 'react';

interface Props {
  activeIndex: number | null;
  width: number | string;
}

const dim = (active: number | null, i: number) => (active === null || active === i ? 1 : 0.45);

export function PyramidSvg({ activeIndex, width }: Props) {
  const uid = useId().replace(/:/g, '_');
  const gV23 = `${uid}v23`;
  const gV99 = `${uid}v99`;
  const gV232 = `${uid}v232`;
  const gV74 = `${uid}v74`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="412 238 156 162"
      width={width}
      style={{ height: 'auto' }}
      aria-hidden="true">
      <defs>
        <linearGradient
          id={gV23}
          x1="214.2"
          y1="242.2"
          x2="234.4"
          y2="242.2"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1b76a4" />
          <stop offset="1" stopColor="#249bd7" />
        </linearGradient>
        <linearGradient
          id={gV99}
          x1="419.8"
          y1="368.2"
          x2="489.7"
          y2="368.2"
          gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#001f33" />
          <stop offset=".6" stopColor="#002035" />
          <stop offset=".8" stopColor="#00243c" />
          <stop offset="1" stopColor="#002b47" />
        </linearGradient>
        <linearGradient id={gV232} x1="461.1" y1="324.4" x2="489.7" y2="324.4" href={`#${gV23}`} />
        <linearGradient
          id={gV74}
          x1="458.5"
          y1="272.4"
          x2="489.7"
          y2="272.4"
          gradientUnits="userSpaceOnUse">
          <stop offset=".5" stopColor="#747371" />
          <stop offset=".7" stopColor="#777674" />
          <stop offset=".8" stopColor="#82817f" />
          <stop offset=".9" stopColor="#949391" />
          <stop offset="1" stopColor="#a3a2a0" />
        </linearGradient>
      </defs>
      <g style={{ opacity: dim(activeIndex, 2), transition: 'opacity 300ms' }}>
        <polygon
          points="541.9 344.5 489.7 361.9 437.4 344.5 489.7 327.1 541.9 344.5"
          fill="#002b47"
          fillRule="evenodd"
        />
        <polygon
          points="530.9 342.4 489.7 356.1 448.4 342.4 489.7 328.8 530.9 342.4"
          fill="#33566c"
          fillRule="evenodd"
        />
        <polygon
          points="513.3 340.9 489.7 348.8 466 340.9 489.7 333.1 513.3 340.9"
          fill="#668091"
          fillRule="evenodd"
        />
        <polygon
          points="559.6 368.8 489.7 391.8 489.7 362 541.9 344.5 559.6 368.8"
          fill="#002b47"
          fillRule="evenodd"
        />
        <polygon
          points="489.7 362 489.7 391.8 419.8 368.8 437.4 344.5 489.7 362"
          fill={`url(#${gV99})`}
          fillRule="evenodd"
        />
        <polygon
          points="496.1 341.8 489.7 344 483.2 341.8 489.7 339.7 496.1 341.8"
          fill="#99aab6"
          fillRule="evenodd"
        />
      </g>
      <g style={{ opacity: dim(activeIndex, 1), transition: 'opacity 300ms' }}>
        <polygon
          points="489.7 298.7 474.5 303.7 474.5 303.7 458.5 298.3 473.9 293.4 489.7 298.7"
          fill="#33657f"
          fillRule="evenodd"
        />
        <polygon
          points="474.5 303.7 461.1 335.5 452.5 332.6 437.4 327.6 450.3 309.7 458.4 298.5 458.5 298.3 458.6 298.4 473.6 303.4 474.5 303.7"
          fill="#4991b6"
          fillRule="evenodd"
        />
        <polygon
          points="504.8 303.7 489.7 308.7 474.5 303.7 489.7 298.6 504.8 303.7"
          fill="#1b76a4"
          fillRule="evenodd"
        />
        <polygon
          points="489.7 308.7 489.7 345 483.2 342.9 461.1 335.5 474.5 303.7 483.2 306.6 489.7 308.7"
          fill={`url(#${gV232})`}
          fillRule="evenodd"
        />
        <polygon
          points="518.2 335.5 496.8 342.7 489.7 345 489.7 308.7 496.8 306.4 504.8 303.7 518.2 335.5"
          fill="#1c9bd7"
          fillRule="evenodd"
        />
        <polygon
          points="505.4 293.4 489.7 298.6 473.9 293.4 489.7 288.3 505.4 293.4"
          fill="#688a9a"
          fillRule="evenodd"
        />
        <polygon
          points="504.8 303.7 518.2 335.5 526.8 332.6 541.9 327.6 529.1 309.7 521 298.5 520.9 298.3 520.7 298.4 505.8 303.4 504.8 303.7"
          fill="#d3ebf7"
          fillRule="evenodd"
        />
        <polygon
          points="520.9 298.3 504.8 303.7 489.7 298.7 505.4 293.4 520.9 298.3"
          fill="#a1afb6"
          fillRule="evenodd"
        />
      </g>
      <g style={{ opacity: dim(activeIndex, 0), transition: 'opacity 300ms' }}>
        <polygon
          points="520.9 288.2 489.7 298.6 489.7 298.6 489.7 246.1 520.9 288.2"
          fill="#a3a2a0"
          fillRule="evenodd"
        />
        <polygon
          points="489.7 246.1 489.7 298.6 458.5 288.2 489.7 246.1"
          fill={`url(#${gV74})`}
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}
